<template>
  <div v-if="isReady">
    <div class="filter-sidebar">
      <div class="filter-chips">
        <button
          class="filter-chip chip-premium"
          :class="{ active: isShowOnlyPremium }"
          @click="isShowOnlyPremium = !isShowOnlyPremium; if (isShowOnlyPremium) isShowOnlyPurchased = false"
        >
          <i aria-hidden="true" class="fa fa-diamond"></i>
          プレミアム動画のみ表示
        </button>
        <button
          v-if="isBasicPlan"
          class="filter-chip chip-purchased"
          :class="{ active: isShowOnlyPurchased }"
          @click="isShowOnlyPurchased = !isShowOnlyPurchased; if (isShowOnlyPurchased) isShowOnlyPremium = false"
        >
          <i class="fa fa-check" aria-hidden="true"></i>
          購入済み動画のみ表示
        </button>
      </div>
      <div class="form-group">
        <select v-model="sort" class="form-control">
          <option value="">公開日順</option>
          <option value="likes">いいね数順</option>
          <option value="comments">コメント数順</option>
        </select>
      </div>
    </div>
    <div class="video-grid" id="videoGrid">
      <a v-for="video in videos"
        class="video-link"
        :key="video.id"
        :title="video.title"
        @click.stop="$emit('handleClickViewVideo', video)"
        >
        <div class="video-card">
          <div class="thumbnail-wrapper">
            <img :src="video.thumbnail" :alt="video.title" class="thumbnail" loading="lazy">
            <span v-if="video.isTargetPremium" class="premium-badge">
              <i aria-hidden="true" class="fa fa-diamond"></i>
              プレミアム
            </span>
            <span v-if="isBasicPlan && video.isTargetPremium && video.isPurchased" class="purchased-badge">
              <i class="fa fa-check" aria-hidden="true"></i>
              購入済み
            </span>
          </div>
          <div class="video-info">
            <div class="channel-avatar" :style="{ backgroundImage: `url(${categories[`${video.category}`].iconUrl})` }"></div>
            <div class="video-info-main">
              <div class="video-title" :title="video.title">{{ video.title }}</div>
              <div class="text-gray">
                <div class="category-name">{{ categories[`${video.category}`].name }}</div>
                <div class="flexbox gap-10">
                  <span> {{ video.createDate }}</span>
                  <span>
                    <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                    {{ video.likes }}
                  </span>
                  <span>
                    <i class="fa fa-comments-o" aria-hidden="true"></i>
                    {{ video.comments }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      isReady: false
    }
  },
  computed: {
    videos () {
      return this.$store.getters.getDispVideos
    },
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    },
    hasPurchased () {
      return id => this.$store.getters.hasPurchasedVideo(id)
    },
    categories () {
      const obj = this.$store.getters.getCategories.reduce((acc, { id, name, iconUrl }) => {
        acc[id] = { name, iconUrl }
        return acc
      }, {})
      return obj
    },
    isShowOnlyPremium: {
      get () {
        return this.$route.query.only_premium === 'true'
      },
      set (val) {
        const query = { ...this.$route.query }
        if (val) {
          query.only_premium = 'true'
        } else {
          delete query.only_premium
        }
        this.$router.replace({ query })
      }
    },
    isShowOnlyPurchased: {
      get () {
        return this.$route.query.only_purchased === 'true'
      },
      set (val) {
        const query = { ...this.$route.query }
        if (val) {
          query.only_purchased = 'true'
        } else {
          delete query.only_purchased
        }
        this.$router.replace({ query })
      }
    },
    sort: {
      get () {
        return this.$store.getters.getSort
      },
      set (val) {
        this.sortVideos(val)
      }
    }
  },
  mounted () {
    const logParams = {
      name: eventCode.video.list,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  methods: {
    async filterVideos () {
      this.loader = this.$loading.show()
      await this.sleep()
      await this.$store.dispatch('filterVideos', {
        searchQuery: this.$route.query.search_query || '',
        category: this.$route.query.category || '',
        onlyPremium: this.$route.query.only_premium || '',
        onlyPurchased: this.$route.query.only_purchased || ''
      })
      this.isReady = true
      this.loader && this.loader.hide()
    },
    async sortVideos (val) {
      this.loader = this.$loading.show()
      await this.sleep()
      this.$store.commit('setSortVideos', val)
      await this.$store.dispatch('sortVideos')
      this.loader && this.loader.hide()
    },
    async sleep (time = 500) {
      await new Promise(resolve => setTimeout(resolve, time))
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler () {
        this.filterVideos()
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
.hpanel {
  background-color: #fff;
  padding: 20px;
}
.filter-sidebar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
  .form-group {
    margin: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    .form-control {
      color: #666;
      border: 1px solid #ccc !important;
    }
  }
}
.filter-chips {
  display: flex;
  gap: 8px;
}
.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 2px solid;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  &:hover {
    opacity: 0.8;
  }
  &.chip-premium {
    /* background: rgba(247, 199, 56, 0.08); */
    background: #fff;
    border-color: rgba(207, 155, 0, 0.5);
    color: #a07800;
    &.active {
      background: rgba(236, 178, 1, 0.5);
      border-color: rgba(207, 155, 0, 1);
      color: #7a5c00;
    }
    i.fa-diamond {
      animation: rotateY 2s linear infinite;
    }
  }
  &.chip-purchased {
    /* background: rgba(39, 174, 96, 0.08); */
    background: #fff;
    border-color: rgba(39, 174, 96, 0.5);
    color: #1e8449;
    &.active {
      background: rgba(3, 187, 80, 0.22);
      border-color: rgba(39, 174, 96, 1);
      color: #145a32;
    }
  }
}
.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  align-items: stretch;
  .video-link {
    text-decoration: none;
    color: inherit;
    display: block;
    height: 100%;
    position: relative;
  }
  .video-card {
    background: #f9f9f9;
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.2s;
    border: 1px solid #ddd;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .video-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  .thumbnail-wrapper {
    position: relative;
  }

  .thumbnail {
    width: 100%;
    display: block;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    padding: unset;
    margin: unset;
    line-height: unset;
    background-color: unset;
    border: unset;
    border-radius: unset;
  }

  .video-info {
    padding: 10px;
    display: flex;
    gap: 10px;
  }

  .video-info-main {
    flex: 1;
    min-width: 0;
  }

  .video-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .category-name {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/video/VideoList.vue